export class Project {
    id: string = '';
    name: string = "";
}